<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">

import ConveyorTLBR from '@/components/Sections/Resources/Elements/Conveyor/ConveyorTLBR.vue'

import { defineProps, computed } from 'vue'
import type { PropType } from 'vue';
import type OreConversion from '@/types/OreConversion.ts'
import ConveyorTRBL from '@/components/Sections/Resources/Elements/Conveyor/ConveyorTRBL.vue'
import { usePlanetStore } from '@/stores/planetStore.ts'
import { CDN } from '@/models/cdn.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { useAssetStore } from '@/stores/assetStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const planetStore = usePlanetStore()
const gameStore = useGameStore()
const assetStore = useAssetStore()

const props = defineProps({
  left: {
    type: Number,
    required: true
  },
  top: {
    type: Number,
    required: true
  },
  height: {
    type: Number,
    required: true
  },
  width: {
    type: Number,
    required: true
  },
  ore: {
    type: Number,
    required: true
  },
  processed: {
    type: Object as PropType<OreConversion>,
    required: true
  },
  conveyorType: {
    type: String,
    required: false,
    default: 'left'
  },
  debug: {
    type: Boolean,
    required: false,
    default: false
  }
})

const terraformerCount = computed(() => {
  return planetStore.countPlanetsTerraForming()
})

const hasTerraformingTech = computed(() => {
  const tech = assetStore.findTechByCode('terraforming')
  return tech ? gameStore.hasPlayerTech(tech.id) : false
})

const openTerraformingModal = () => {
  if (hasTerraformingTech.value) {
    gameStore.showModal('resourceTerraforming')
  }
}

</script>

<template>
<div :class="{
          'absolute':true,
          'border':debug
        }"
     :style="'top:' + top + 'rem;left:' + left + 'rem;width:' + width + 'rem;height:' + height + 'rem;'">

  <!-- Left -->
  <ConveyorTLBR
    v-if="conveyorType == 'right'"
    :left="1.25"
    :top="1"
    :height="18"
    :width="3"
    :midTime="0.15"
    :min-speed="5"
    :object-image="CDN.icon('ore' + ore)"
    :conversion="processed"
    :debug="debug"
  />

  <!-- Right -->
  <ConveyorTRBL
    v-else-if="conveyorType == 'left'"
    :left="3.5"
    :top="1"
    :height="18"
    :width="4"
    :midTime="0.15"
    :min-speed="5"
    :object-image="CDN.icon('ore' + props.ore)"
    :conversion="processed"
    :debug="debug"
  />



  <div :class="{
            'absolute rounded bg-slate-800 border':true,
            'border-slate-700 hover:border-slate-600 cursor-pointer': hasTerraformingTech,
            'border-slate-800 cursor-not-allowed': !hasTerraformingTech,
            'opacity-50':debug
          }"
       style="top:18rem;left:0;width:8rem;z-index:15"
       @click="openTerraformingModal"
  >
    <div class="flex-col p-1">
      <img
        :class="{
          'rounded' : true,
          'grayscale': !hasTerraformingTech
        }"
        alt="Terraforming Technology"
        :src="CDN.building(128,'terraforming_command_center')">
      <div class="text-center text-green-500 pt-1" v-if="terraformerCount > 0 && hasTerraformingTech">{{ t('resources.terraforming.planetsTerraforming', { count: terraformerCount }) }}</div>
      <div class="text-center text-red-500 pt-1" v-else-if="!hasTerraformingTech">{{ t('resources.terraforming.techRequired') }}</div>
      <div class="text-center pt-1" v-else>{{ t('resources.terraforming.title') }}</div>
    </div>
  </div>

</div>
</template>

<style scoped lang="scss">

</style>